module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"action":{"toggle":"Toggle navigation"}}}')
  delete Component.options._Ctor
}
